module.exports = __webpack_public_path__ + "static/4-2759b38c30def3bd899455c1202d371c.png";